import GQLTable from '../../utils/gql-mui-rhf/Table';

// material
import { Box, Grid, Container, Typography } from '@mui/material';
// components
import Page from '../../components/Page';
// ----------------------------------------------------------------------

export default function People() {
    return (
        <Page title="Users | FINBACK670">
            <Container maxWidth="xl">
                <Box sx={{ pb: 5 }}>
                    <Typography variant="h4">Users</Typography>
                </Box>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <GQLTable
                            queryString={'users'}
                            addMutationString={'createUser'}
                            deleteMutationString={'deleteUser'}
                            restrictedColumns={{password: true}}
                            // updateMutationString={'updateUser'}
                            updateModal={true}
                        />
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}
